import React, { useCallback, useState } from "react";
import { ITkAddressSearchByPostalCode } from "../../../type/componentsType/TkAddressSearchByPostalCode";
import { Box } from "@mui/material";
import TkSuperPowerText from "../TkSuperPowerText";
import TkButton from "../../atoms/TkButton";
import { httpGetPostalCode } from "./api/request";
import "./_style.scss";
import ModalForPostalCode from "./ModalForPostalCode";
import { AddressList } from "../../../type/apiType/IAPI_COM013";

/**
 * 郵便番号住所検索部品
 * 郵便番号による住所検索を行うコンポーネント
 * @param getPostalCodeValue - 郵便番号が選択されたときに実行されるコールバック関数
 * @return TkAddressSearchByPostalCode 郵便番号住所検索部品
 */
const TkAddressSearchByPostalCode: React.FC<ITkAddressSearchByPostalCode> = (
  props
) => {
  const {
    getPostalCodeValue,
    getError,
    onChange,
    onClick,
    onGetValue,
    disabled,
    wantToSetValue,
    hideButton = false,
    ...rest
  } = props;
  const postCodeRef = React.useRef("");
  const postCode = postCodeRef.current;
  const setPostCode = (value: any) => {
    postCodeRef.current = value;
  };
  const [showList, setShowList] = useState<AddressList[]>([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [error, setError] = useState("");

  const handlePost = (e: { target: { value: string; showValue: string } }) => {
    const realValue = e.target.value;
    setPostCode(realValue);

    onGetValue && onGetValue(realValue);

    onChange &&
      onChange({ target: { value: realValue, showValue: e.target.showValue } });
  };

  const handleClick = useCallback(async () => {
    if (!postCode || postCode.length !== 7) {
      return;
    }
    setOpen(true);
    setShowList([]);
    setLoading(true);
    setError("");

    const res = await httpGetPostalCode({ zipcode: postCode });

    if (res.resultCd === "I0000") {
      onClick && onClick(res.results ? res.results : []);
      setShowList(res.results ? res.results : []);
    } else {
      setError(res.resultCd ?? "");
      onClick && onClick([]);
    }
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getError, postCode]);

  const getSuccess = (value: any) => {
    const {
      address1,
      address2,
      address3,
      kana1,
      kana2,
      kana3,
      prefcode,
      zipcode,
    } = value;

    const valueMap = {
      address1: address1 ?? "",
      address2: address2 ?? "",
      address3: address3 ?? "",
      kana1: kana1 ?? "",
      kana2: kana2 ?? "",
      kana3: kana3 ?? "",
      prefcode: prefcode ?? "",
      zipcode: zipcode ?? "",
    };
    getPostalCodeValue && getPostalCodeValue({ value: valueMap });
  };

  return (
    <Box
      data-testid="tkAddressSearchByPostalCode"
      className="tkAddressSearchByPostalCode"
    >
      <TkSuperPowerText
        type="postcode"
        size="small"
        onChange={handlePost}
        disabled={disabled}
        wantToSetValue={wantToSetValue}
        {...rest}
      ></TkSuperPowerText>

      {!hideButton && (
        <TkButton
          ml
          onClick={handleClick}
          disabled={disabled}
          data-testid="tkAddressSearchByPostalCodeBtn"
        >
          住所検索
        </TkButton>
      )}

      <ModalForPostalCode
        loading={loading}
        open={open}
        controlOpen={setOpen}
        showList={showList}
        postcode={postCode}
        onSuccess={getSuccess}
        errorMsgId={error}
      ></ModalForPostalCode>
    </Box>
  );
};

export default TkAddressSearchByPostalCode;
